






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { OptionalProp } from '@pjn/vue-core/component';

/**
 * Snackbar de Vuetify que lanza un evento cuando debe cerrarse y espera a ser cerrado desde afuera.
 */
@Component
export default class Snackbar extends Vue {
  /** Mostrar en la parte superior */
  @Prop() top: boolean;

  /** Mostrar en la parte inferior */
  @Prop() bottom: boolean;

  /** Mostrar en la izquierda */
  @Prop() left: boolean;

  /** Mostrar en la derecha */
  @Prop() right: boolean;

  /** Aumentar altura para que entren mas lineas */
  @Prop() multiLine: boolean;

  /** Indica si debe ser visible o no */
  @Prop() value: boolean;

  /** Color de fondo */
  @OptionalProp() color: string;

  /** Tiempo que debe mostrarse  */
  @Prop({type: Number, required: false}) dismissTime?: number;

  private dismissHandler: any = null;

  private created() {
    this.statusChanged();
  }

  private destroyed() {
    this.clearTimeout();
  }

  private clearTimeout() {
    if (this.dismissHandler) clearTimeout(this.dismissHandler);
  }

  @Watch('value')
  private onValueChanged() {
    this.statusChanged();
  }

  private statusChanged() {
    this.clearTimeout();

    if (this.value && this.dismissTime) {
      this.dismissHandler = setTimeout(() => (this.onStatusChanged(false)), this.dismissTime);
    }
  }

  private onStatusChanged(e: boolean) {
    this.$emit(e ? 'open' : 'close');
    this.$emit('input', e);
  }
}
